import VectorSource from "ol/source/Vector";
import { fromLonLat } from "ol/proj";

export default {
  data() {
    return {
      powiatyLayer: undefined,
      powiatyLabelsLayer: undefined,
      gminySource: undefined,
      gminyLayer: undefined,
      gminyLabelsLayer: undefined,
      gminyLabelsSource: undefined,
      ficzeryLayer: undefined,
      ficzeryZainwestLayer: undefined,
      ficzerySource: undefined,
      map: undefined,
      selectionLayer: undefined,
      cartogramActive: undefined
    }
  },
  methods: {
    powiatFeatureByNazwa(powiat_nazwa) {
      return this.powiatyLayer.getSource().getFeatures().filter(f => f.get('nazwa') == powiat_nazwa)[0];
    },
    gminyView(powiat_nazwa) {
      this.cartogramActive = true;
      this.powiatyLayer.setVisible(false);
      this.powiatyLabelsLayer.setVisible(false);
      this.setLayerVisibility("ficzery", false)
      this.setLayerVisibility("ficzeryZainwest", false)
      this.gminySource.clear();
      this.selectionLayer.getSource().clear();
      this.gminySource.addFeatures(
        this.gminy_source_cache.filter(g => {
          return g.get("powiat_nazwa") == powiat_nazwa;
        })
      );
      this.gminyLabelsSource.clear();
      this.gminyLabelsSource.addFeatures(
        this.gminy_labels_cache.filter(g => {
          return g.get("powiat_nazwa") == powiat_nazwa;
        })
      );
      this.gminyLayer.setVisible(true);
      this.gminyLabelsLayer.setVisible(true);
      let feature = this.powiatFeatureByNazwa(powiat_nazwa);
      this.zoomToFeature(feature);
    },
    hasFiczeryForGminaByNazwa(gmina_nazwa) {
      return this.ficzery_source_cache.some(f => {
        return f.get("gmina_nazwa") == gmina_nazwa;
      })
    },
    ficzeryForGminaByNazwa(gmina_nazwa) {
      return this.ficzery_source_cache.filter(f => {
        return f.get("gmina_nazwa") == gmina_nazwa;
      })
    },
    ofertyViewNoZoom() {
      this.cartogramActive = true;
      this.gminyLayer.setVisible(false);
      this.gminyLabelsLayer.setVisible(false);
      this.setLayerVisibility("ficzery", true);
      this.setLayerVisibility("ficzeryZainwest", true);
      this.ficzeryZainwestLayer.setVisible(true);
    },
    ofertyView(gmina_nazwa) {
      this.ofertyViewNoZoom();
      this.ficzerySource.clear();
      this.selectionLayer.getSource().clear();
      let ficzery = this.ficzeryForGminaByNazwa(gmina_nazwa);
      this.ficzerySource.addFeatures(ficzery);
      if (ficzery.length > 0) {
        this.zoomToFeature(this.ficzerySource.getFeatures());
      }
    },
    ofertaView(oferta) {
      this.ofertyViewNoZoom();
      let ofertaF = this.ficzerySource.getFeatures().filter(f => f.get("id") == oferta.id)[0]
      let source = this.selectionLayer.getSource();
      source.clear();
      source.addFeature(ofertaF);
      this.zoomToFeature(ofertaF);
    },
    ofertaViewS(selected_oferta) {
      this.ofertyViewNoZoom();
      let oferta = this.ficzeryZainwestLayer.getSource().getFeatures().filter(f => f.get("nazwa")['pl'] == selected_oferta)[0]
      let source = this.selectionLayer.getSource();
      source.clear();
      source.addFeature(oferta);
      this.zoomToFeature(oferta);
    },
    powiatyView() {
      this.cartogramActive = false;
      this.gminySource.clear();
      this.gminySource.addFeatures(this.gminy_source_cache);
      this.ficzerySource.clear();
      this.ficzerySource.addFeatures(this.ficzery_source_cache);
      this.selectionLayer.getSource().clear();
      this.setLayerVisibility("ficzery", false)
      this.setLayerVisibility("ficzeryZainwest", false);
      this.ficzeryZainwestLayer.setVisible(false);
      this.gminyLayer.setVisible(false);
      this.gminyLabelsLayer.setVisible(false);
      this.powiatyLayer.setVisible(true);
      this.powiatyLabelsLayer.setVisible(true);
      this.map.getView().animate({
        center: fromLonLat([16.706, 51.105]),
        zoom: 8,
        duration: 1000
      });
    },
    zoomToFeature(feature) {
      let extentSource = new VectorSource({
        features: Array.isArray(feature) ? feature : [feature]
      });
      let extent = extentSource.getExtent();
      if (extentSource.getFeatures().length > 1) {
        extent[0] -= 800;
        extent[1] -= 800
        extent[2] += 800
        extent[3] += 800
      }
      else {
        extent[0] -= 100;
      }
      setTimeout(() => this.map.getView().fit(extent, { duration: 1000 }), 0);
    }
  },
  mounted() {
    this.$root.$on("cartogramPowiatyView", () => {
      this.powiatyView();
    })
    this.$root.$on("cartogramGminyView", selected_powiat => {
      this.gminyView(selected_powiat);
    })
    this.$root.$on("cartogramOfertyView", selected_gmina => {
      this.ofertyView(selected_gmina);
    })
    this.$root.$on("cartogramOfertyViewNoZoom", () => {
      this.ofertyViewNoZoom();
    })
    this.$root.$on("cartogramOfertaViewS", selected_oferta => {
      this.ofertaViewS(selected_oferta);
    })
  }
}